<ng-form #stepForm="ngForm">
  <!-- trade references -->
  <h3 class="h3">{{'Trade References' | translate}}</h3>

  <input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
  <input class="input p-b-6-m p-b-5-s p-t-7-s"
    type="text"
    name="ref_name"
    required
    sl-input="ref_name"
    [(ngModel)]="data.ref_name"
    [muiInput]="'Name' | translate">
</input-wrap>

<input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
<textarea class="textarea p-b-6-m p-b-5-s p-t-7-s"
  style="resize:none;"
  name="ref_address"
  required
  sl-input="ref_address"
  [(ngModel)]="data.ref_address"
[muiInput]="'Address' | translate"></textarea>
</input-wrap>

<input-wrap class="block m-t-5 m-t-7-m m-t-7-s overflow-hidden">
<input class="input p-b-6-m p-b-5-s p-t-7-s"
  type="text"
  name="ref_telephone"
  validatePattern="telephone"
  inputmode="tel"
  required
  autocomplete="tel"
  sl-input="ref_telephone"
  [(ngModel)]="data.ref_telephone"
  [muiInput]="'Telephone' | translate">
</input-wrap>

@if (content.termsCopy) {
  <input-wrap>
  <div class="flex flex-top m-t-6">
    <checkbox name="termsAndConditions"
      required
      [(ngModel)]="data.terms_and_conditions"
      (checkedChange)="detectChanges()">
    </checkbox>
    <p>
      <a [attr.href]="app.url.toMediaUrl(content.termsFile)"
        target="_blank"
      *iCms="'termsCopy' of content; content: 'html'"></a>
      <span class="col-2">*</span>
    </p>
  </div>
</input-wrap>
}
</ng-form>
